export type WithState<State, reducer extends string> = {
  [P in reducer]: State;
};

export const thunkPrefix = (reducer: string, thunk: string) => `${reducer}/${thunk}`;
